module.exports = __webpack_public_path__ + "img/NOTA-PCP2.c9dff4f3.png";